import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';
export const TOGGLE_WOOTRIC_SURVEY_CAP = defineCapability({
  name: 'TOGGLE_WOOTRIC_SURVEY_CAP',
  args: {
    surveyName: args.string()
  }
});